// Mirror of accounting-backend-alt1/company-management/constants/companyTypes.js.
//
// Single source of truth on the frontend for the canonical Pascal-case
// list of Swedish company types accepted by the catalog
// `company_details.company_type` ENUM. Keep in sync with the backend
// constant — both are bound to the catalog migration
// `01_catalog_company_type_expansion.sql`.
//
// Bostadsrättsförening is intentionally excluded per
// docs/company-types/_decisions.md Q1 / Q4 (BRF deferred).

export const COMPANY_TYPES = Object.freeze([
  'Aktiebolag',
  'Handelsbolag',
  'Enskild firma',
  'Kommanditbolag',
  'Ekonomisk förening',
  'Ideell förening',
  'Stiftelse',
]);

export const COMPANY_TYPE_TO_SHORT_CODE = Object.freeze({
  'Aktiebolag': 'AB',
  'Handelsbolag': 'HB',
  'Enskild firma': 'EF',
  'Kommanditbolag': 'KB',
  'Ekonomisk förening': 'EK',
  'Ideell förening': 'IF',
  'Stiftelse': 'ST',
});

export function isValidCompanyType(value) {
  return typeof value === 'string' && COMPANY_TYPES.includes(value);
}

export function toShortCode(companyType) {
  return COMPANY_TYPE_TO_SHORT_CODE[companyType] || null;
}
